// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-Ogd","questions":"styles_questions__Z0Mhw","footer":"styles_footer__1yEEZ"};